var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 15.9953,
    viewBox: "0 0 32 15.9953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32 0H16C7.16352 0 0 7.16143 0 15.9953H16C24.8365 15.9953 32 8.8339 32 0Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 7.99753H8.04045C3.59988 7.99753 7.58267e-06 11.5782 7.58267e-06 15.9952H7.95956C12.4003 15.9952 16 12.4145 16 7.99753Z",
    fill: "#E0D65F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif04);
export default __webpack_public_path__ + "static/media/motif-04.dc78f7df74c1eee014a136563bb27fef.svg";
export { ForwardRef as ReactComponent };